import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getEvents = (state: RootState) => state.pages.editor.documents.past.length - 1;

const getUndoEvents = createSelector([getEvents], (events) => events);

export default getUndoEvents;
